import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { PublisherApp } from './publisher.component';
import { VcaAlertsService } from '../../../common/vca-alerts';
import { AppState } from '../../../app/app.service';
import {NspUpgradeComponent} from './upgrade/nsp-upgrade.component';
import { routing } from './publisher.routes';
import {UpgradeDate} from './upgradedate/upgrade-date.component';
import { NspUpgradeService } from './upgrade/nsp-upgrade.service';
import { FeatureEnablementService } from './upgrade/feature-enablement.service';

import '../../../styles/styles.scss';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ClarityModule.forRoot(),
    VcaCommonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    routing
  ],
  declarations: [
    PublisherApp,
    NspUpgradeComponent,
    UpgradeDate,
    //...APPLICATION_DECLARATIONS
  ],
  providers: [
    //...APPLICATION_PROVIDERS,
    AppState,
    Title,
    NspUpgradeService,
    FeatureEnablementService
  ],
  bootstrap: [ PublisherApp ]
})
export class PublisherAppModule {
}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/publisher.module.ts